import { useEffect } from "react"

export default (title = false) => {
    useEffect(()=>{
        document.title = `Wisemans Surf Lodge${title ? `: ${title}` : '' }`;
    },[])
}